import { Table, Spin, message, Typography, Button } from "antd";
import React, { useEffect, useState } from "react";
import dataService from "../networks/api/service/dataService";
import { useLocation, useNavigate } from "react-router-dom";
import colors from "../assets/styles/colour";
import { LeftOutlined } from "@ant-design/icons";
import "./TableComponent/CustomTable.css";

function AllLevelBriefDetails() {
  const location = useLocation();
  const navigate = useNavigate();
  

  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [columns, setColumns] = useState([]);

  const yearSelected = location.state?.yearSelected || null;
  const firstDropDown = location.state?.firstDropDown || null;
  const secondDropDown = location.state?.secondDropDown || null;
  console.log(secondDropDown, "second", firstDropDown, "first");

  const { selectedAssembly, year, electionType, assemblyName } =
    location.state.data || {};
  console.log(assemblyName, "assemblyName");
  // Transform data for side-by-side comparison
  // const transformDataForComparison = (data) => {
  //   const headers = {};

  //   // Aggregate data by header
  //   data.forEach((entry) => {
  //     const { year, electionDetails, position, votePercentage, repeat } = entry;

  //     // Combine all keys into a single object
  //     const allData = {
  //       ...electionDetails,
  //       ...position,
  //       ...votePercentage,
  //       ...repeat,
  //     };

  //     // Iterate over all keys
  //     for (const [key, value] of Object.entries(allData)) {
  //       if (!headers[key]) {
  //         headers[key] = { header: key };
  //       }
  //       headers[key][year] = value !== null ? value : "-";
  //     }
  //   });

  //   // Convert to array for Ant Design Table
  //   return Object.values(headers);
  // };

  const transformDataForComparison = (data) => {
    const headers = {};
    const latestEntries = {};
    const addedYears = new Set();

    // Reverse the array so latest entries come first
    const reversedData = [...data].reverse();

    reversedData.forEach((entry) => {
      const { year } = entry;

      if (!addedYears.has(year)) {
        // If year is not already added, process it
        addedYears.add(year);
        latestEntries[year] = entry;
      }
    });

    // Now process the cleaned data without duplicates
    Object.values(latestEntries).forEach((entry) => {
      const { year, electionDetails, position, votePercentage, repeat } = entry;
      const allData = {
        ...electionDetails,
        ...position,
        ...votePercentage,
        ...repeat,
      };

      Object.entries(allData).forEach(([key, value]) => {
        if (!headers[key]) {
          headers[key] = { header: key };
        }
        headers[key][year] = value !== null ? value : "-";
      });
    });
    return Object.values(headers);
  };

  // Handle row click to fetch analysis data
  const handleAssemblyAnalysis = async (record, clickedYear, value) => {
    const { header } = record; // Use the exact header key for the API
    // console.log(header, record, "record");
    // Only proceed if the header matches specific criteria
    if (
      ["above45", "thirtyTo45", "below30", "first", "second", "third"].includes(
        header
      )
    ) {
      const position = ["first", "second", "third"].includes(header)
        ? header
        : null;
      const votePercentage = ["above45", "thirtyTo45", "below30"].includes(
        header
      )
        ? header
        : null;

      setLoading(true);
      try {
        let response;
        if (electionType === "AC") {
          response = await dataService.getAssemblyAnalysisAc(
            selectedAssembly,
            clickedYear,
            votePercentage,
            position
          );
        } else if (electionType === "PC") {
          response = await dataService.getAssemblyAnalysisPc(
            selectedAssembly,
            clickedYear,
            votePercentage,
            position
          );
        }

        if (response && response.data) {
          // setElectionDetails(response.data);
          navigate("/login/all-level-election-page", {
            state: { electionDetails: response.data },
          });
        } else {
          message.error("No data available for the selected criteria.");
        }
      } catch (error) {
        console.error(error);
        message.error("Error fetching data.");
      } finally {
        setLoading(false);
      }
    }
  };

  // Fetch data
  const fetchAssemblyData = async () => {
    setLoading(true);
    try {
      let response;
      if (electionType === "AC") {
        response = await dataService.getAssemblyElectionAc(
          selectedAssembly,
          year
        );
      } else if (electionType === "PC") {
        response = await dataService.getAssemblyElectionPc(
          selectedAssembly,
          year
        );
      }
      console.log("Data=", response.data);
      if (response && response.data) {
        const transformedData = transformDataForComparison(response.data);

        // const years = response.data.map((item) => item.year);
        const years = [];
        const seenYears = new Set();

        response.data.reverse().forEach((item) => {
          if (!seenYears.has(item.year)) {
            seenYears.add(item.year);
            years.push(item.year);
          }
        });

        const dynamicColumns = [
          {
            title: "Header",
            dataIndex: "header",
            key: "header",
            render: (text, record) => {
              const isClickable = [
                "above45",
                "thirtyTo45",
                "below30",
                "first",
                "second",
                "third",
              ].includes(record.header);
              return (
                <span
                  style={{
                    cursor: isClickable ? "pointer" : "default",
                    textDecoration: isClickable ? "underline" : "none",
                    color: isClickable ? "black" : "inherit",
                    transition: "color 0.3s ease",
                  }}
                  onMouseEnter={(e) =>
                    isClickable && (e.target.style.color = "blue")
                  }
                  onMouseLeave={(e) =>
                    isClickable && (e.target.style.color = "black")
                  }
                >
                  {text
                    .replace(/([a-z])([A-Z])/g, "$1 $2")
                    .replace(/_/g, " ")
                    .toUpperCase()}
                </span>
              );
            },
          },
          ...years.map((yr) => ({
            title: yr,
            dataIndex: yr,
            key: yr,
            width: `${70 / years.length}%`,
            onCell: (rowRecord) => {
              const isClickable = [
                "above45",
                "thirtyTo45",
                "below30",
                "first",
                "second",
                "third",
              ].includes(rowRecord.header);
              return {
                onClick: () => handleCellClick(rowRecord, yr, rowRecord[yr]),
                style: {
                  cursor: isClickable ? "pointer" : "default",
                  transition: "background 0.3s ease", // Smooth transition effect
                },
                onMouseEnter: (e) => {
                  if (isClickable) {
                    e.currentTarget.style.background = "#cce7ff"; // Change background on hover
                  }
                },
                onMouseLeave: (e) => {
                  if (isClickable) {
                    e.currentTarget.style.background = "transparent"; // Reset to default
                  }
                },
              };
            },
          })),
        ];
        setTableData(transformedData);
        setColumns(dynamicColumns);
      } else {
        message.error("No data available for the selected criteria.");
      }
    } catch (error) {
      console.error(error);
      message.error("Error fetching data.");
    } finally {
      setLoading(false);
    }
  };

  const handleCellClick = (record, clickedYear, value) => {
    console.log("Row record:", record); // e.g., "above45"
    console.log("Column Year:", clickedYear); // e.g., "2023"
    console.log("Cell Value:", value); // e.g., "50%"
    handleAssemblyAnalysis(record, clickedYear, value);
    // Perform logic or API call
    // message.info(
    //   `Row: ${record.header}, Column: ${clickedYear}, Value: ${value}`
    // );
  };

  useEffect(() => {
    if (selectedAssembly && year && electionType) {
      fetchAssemblyData();
    }
  }, [selectedAssembly, year, electionType]);

  return (
    <div style={{ padding: "20px" }}>
      <Typography
        color={colors.textSecondary}
        variant="h3"
        fontWeight="bold"
        style={{ fontSize: "20px", marginBottom: 10 }}
      >
        {assemblyName}
      </Typography>
      <Button
        type="primary"
        icon={<LeftOutlined />}
        onClick={() => {
          console.log(secondDropDown, "second", firstDropDown, "first");
          if (secondDropDown && firstDropDown) {

            navigate("/login/parliament-election-details", {
              state: {
                yearSelectedValue: yearSelected,
                firstDropDownValue: firstDropDown,
                secondDropDownValue: secondDropDown,
              }, // Pass the data dynamically
            });
          } else if (firstDropDown) {
            navigate("/login/assembly-election-details", {
              state: {
                yearSelectedValue: yearSelected,
                firstDropDownValue: firstDropDown,
                secondDropDownValue: secondDropDown,
              }, // Pass the data dynamically
            });
          } else {
            navigate(-1);
          }
          // navigate("/login/assembly-election-details", {
          //   state: {
          //     yearSelectedValue: yearSelected,
          //     firstDropDownValue: firstDropDown,
          //     secondDropDownValue: secondDropDown,
          //   }, // Pass the data dynamically
          // });

          // navigate(-1)
        }}
        style={{ marginBottom: "20px" }}
      >
        Go Back
      </Button>
      {loading ? (
        <Spin size="large" style={{ display: "block", marginTop: "20px" }} />
      ) : (
        <Table
          className="styled-table"
          columns={columns}
          dataSource={tableData}
          rowKey={(record) => record.header}
          pagination={false}
          style={{
            backgroundColor: "#f4f8fc", // Slightly faded background
            borderRadius: "8px",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
          }}
          scroll={{
            y: 520,
            x: "max-content",
          }}

          // onRow={(record) => ({
          //   onClick: () => handleRowClick(record), // Handle row clicks
          // })}
        />
      )}
    </div>
  );
}

export default AllLevelBriefDetails;
